import React from "react";
import { Routes, Route } from "react-router-dom";
import Seasons from "../screens/Seasons/Seasons";
import Season from "../screens/Seasons/Season/Season";
import SeasonBlocks from "../screens/Seasons/Season/Blocks/SeasonBlocks";
import NotFound from "../screens/NotFound";
import Programs from "../screens/Seasons/Programs/Programs";

const SeasonsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Seasons />} />
      <Route path="/programas" element={<Programs />} />
      <Route
        path="/:seasonNumber/*"
        element={
          <Routes>
            <Route path="/" element={<Season />} />
            <Route path="/bloques" element={<SeasonBlocks />} />
            <Route path="/programa" element={<Programs />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        }
      ></Route>
    </Routes>
  );
};

export default SeasonsRoutes;
